import { useState } from 'react';
import { useDeepCompareEffect } from '../utils';

export default function useSimpleRequest({
  request,
  params,
  callbackOnSuccess,
  callbackOnFailure,
}) {
  const [isFetching, changeFetchState] = useState(false);
  const startFetching = () => changeFetchState(true);
  useDeepCompareEffect(() => {
    if (!isFetching) return;
    request(params)
      .then(() => {
        changeFetchState(false);
        callbackOnSuccess();
      })
      .catch(err => {
        changeFetchState(false);
        callbackOnFailure(err);
      });
  }, [isFetching, params]);

  return [isFetching, startFetching];
}
